import Shell from "../../components/shell";
import TransactionsTable from "../../components/tables/transaction-table";
import TxnStatsBar from "../../components/txnStatsBar";

const PaymentsPage = () => {
  return (
    <div>
      <Shell pageHeader={"Financial Metrics"} pageTitle={"Payment"}>
        <div className="space-y-8">
          <TxnStatsBar />
          <div>
            <TransactionsTable />
          </div>
        </div>
      </Shell>
    </div>
  );
};

export default PaymentsPage;
